import { render, staticRenderFns } from "./Exhi.vue?vue&type=template&id=525990d9&scoped=true&"
import script from "./Exhi.vue?vue&type=script&lang=js&"
export * from "./Exhi.vue?vue&type=script&lang=js&"
import style0 from "./Exhi.vue?vue&type=style&index=0&id=525990d9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525990d9",
  null
  
)

export default component.exports